import { GatewayControleQuinquennal } from "@conformite/gateway";
import { InfoCard } from "@endya-conformite/ui-kit";
import styles from "./UnreadDocumentsNotice.module.scss";

type UnreadDocumentsNoticeProps = {
  aiResult?: GatewayControleQuinquennal.ControleQuinquennalAiResult | null;
  className?: string;
};

const REASON_LABELS: Record<string, string> = {
  OCR_FAILED: "format non lisible par l'OCR",
  OCR_EMPTY: "document vide ou illisible",
  EXCLUDED_OTHER_PERSON: "rattachée à une autre personne",
  EXCLUDED_TYPE_FILTER: "type de pièce non attendu à cet emplacement",
  UNSUPPORTED_FORMAT:
    "format non pris en charge par l'analyse (PDF, image, Word ou OpenDocument attendu)",
  TOO_LARGE: "fichier trop volumineux pour l'analyse",
};

function pluralize(count: number): string {
  return count > 1 ? "s" : "";
}

export function UnreadDocumentsNotice({
  aiResult,
  className,
}: UnreadDocumentsNoticeProps) {
  const unreadDocuments = aiResult?.unreadDocuments ?? [];
  if (unreadDocuments.length === 0) return null;

  const analyzed = aiResult?.analyzedDocumentCount;
  const total = aiResult?.totalDocumentCount;

  return (
    <InfoCard type="warning" className={className}>
      <div className={styles.body}>
        <p className={styles.title}>
          {unreadDocuments.length} pièce{pluralize(unreadDocuments.length)}{" "}
          n&apos;{unreadDocuments.length > 1 ? "ont" : "a"} pas pu être analysée
          {pluralize(unreadDocuments.length)}
        </p>
        <ul className={styles.documents}>
          {unreadDocuments.map((document) => (
            <li key={`${document.idFile}-${document.reason}`}>
              <span className={styles.filename}>{document.filename}</span>
              {" — "}
              {REASON_LABELS[document.reason] ?? document.reason}
            </li>
          ))}
        </ul>
        {analyzed !== undefined && total !== undefined && (
          <p className={styles.counts}>
            {analyzed} pièce{pluralize(analyzed)} analysée{pluralize(analyzed)}{" "}
            sur {total}.
          </p>
        )}
      </div>
    </InfoCard>
  );
}
